import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import en from './locales/en.json'
import de from './locales/de.json'
import es from './locales/es.json'
import it from './locales/it.json'
import fr from './locales/fr.json'
import zhCN from './locales/zh-CN.json'
import zhTW from './locales/zh-TW.json'

export const languages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'fr', label: 'Français' },
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
]

const dictionaries = { en, de, es, it, fr, 'zh-CN': zhCN, 'zh-TW': zhTW }
const I18nContext = createContext(null)

const resolve = (dictionary, key) => key.split('.').reduce((value, segment) => value?.[segment], dictionary)

export function I18nProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('rti-tek-language')
    return languages.some((item) => item.code === stored) ? stored : 'en'
  })
  const value = useMemo(() => ({
    language,
    setLanguage: (nextLanguage) => {
      if (languages.some((item) => item.code === nextLanguage)) setLanguage(nextLanguage)
    },
    t: (key) => resolve(dictionaries[language], key) || resolve(en, key) || key,
  }), [language])

  useEffect(() => {
    localStorage.setItem('rti-tek-language', language)
    document.documentElement.lang = language
  }, [language])

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n() {
  const context = useContext(I18nContext)
  if (!context) throw new Error('useI18n must be used inside I18nProvider')
  return context
}
